import React from 'react';
import Heading from '../../../generic-components/Heading';

interface ITotalPairViewProps {
  title: string;
  value: string;
  testId: string;
}
export const TotalPairView = ({ title, value, testId }: ITotalPairViewProps) => {
  // Check if the value is negative and remove the minus sign if it is
  const numberValue = parseFloat(value);
  const isNegative = numberValue < 0;
  const valueWithoutMinus = value.replace('-', '');

  return (
    <div>
      <Heading title={title} className='font-metricR text-sm text-bw07 leading-6 mb-[5px] text-right' />
      <div className='font-metricR text-[28px] text-bw08 leading-6 tracking-[1px] text-left' data-testid={`${testId}`}>
        {isNegative && <span className='font-metricRMedium text-[18px] text-bw08 leading-6 relative top-[-5px]'>-</span>}
        <span className='font-metricRMedium text-sm text-bw08 leading-6 relative top-[-9px]'>$</span>
        { isNegative ? valueWithoutMinus : value}
      </div>
    </div>
  );
};
